export default "//yastatic.net/s3/distribution/pythia/frontend/_/90d1b43ceee7743f0341132812f905e9.png";